import React, { useEffect, useState, useContext } from "react";
import { Modal, Select, Input, DatePicker, Spin, message } from "antd";
import moment from "moment";
import { platformApi } from "../../../../api";
import { ContextAPI } from "../../../../ContextAPI";
import { ENDPOINT } from "../../../../constants";

const { Option } = Select;

export default function FinancerModal({ open, close, data, onPaymentSuccess }) {
  const { loginCredintials } = useContext(ContextAPI);
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState(moment());
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);


  const setEReceipt = async (payload) => {
    // API call removed: Backend now generates the e-receipt ID internally
    return "GENERATED_BY_BACKEND";
  };

  const fetchBranches = async () => {
    try {
      const response = await platformApi.get("/api/company/branches");
      console.log("res ", response);

      const branches = response?.data?.response?.data || [];
      console.log("br ", branches);

      if (response?.data?.code === 200) {
        console.log("h ");

        // extract branch name + account name
        const formattedBranches = branches.map((b) => ({
          name: `${b.name} (${b.bankDetails?.[0]?.accountName || "N/A"})`,
        }));
        setBranchList(formattedBranches);
        console.log("form ", formattedBranches);

      } else {
        message.error("Unable to fetch branches");
      }
    } catch (err) {
      message.error("Error fetching branches");
    }
  };

  const fetchBanks = async (value = "") => {
    try {
      const body = { size: 10, searchString: value, page: 1 };
      const { data } = await platformApi.post("/api/company/branches/get", body);
      if (data?.response?.data?.branch) {
        const banks = data.response.data.branch.flatMap((b) =>
          (b.bankDetails || []).map((bank) => ({
            label: `${bank.name} - ${bank.accountNumber}`,
            value: bank.id,
            key: bank.id,
            balance: bank.accountBalance || 0,
          }))
        );
        setBankList(banks);
      } else {
        setBankList([]);
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to fetch banks");
    }
  };

  useEffect(() => {
    if (open) {
      fetchBanks();
      if (data) {
        const billAmount = parseFloat(data?.loan?.disbursementAmount || 0);
        const totalCollected = Array.isArray(data?.financePayments)
          ? data.financePayments.reduce(
            (sum, p) => sum + (parseFloat(p.collectedAmount) || 0),
            0
          )
          : 0;
        const pending = billAmount - totalCollected;

        // Set default amount to empty so pending shows fully
        setAmount("");
      }
    }
  }, [open]);


  // --- Handle submit (create payment) ---
  const handleSubmit = async () => {
    if (!amount || !selectedBank) {
      message.error("Please select a bank and enter amount");
      return;
    }

    try {
      setSubmitting(true);

      const ReceiptId = await setEReceipt({
        branch: data?.branch?.id  // use booking branch
      });

      if (!ReceiptId) {
        message.error("Failed to generate receipt ID");
        setSubmitting(false);
        return;
      }

      const payload = {
        module: "FINANCER_DUE",
        moduleId: data?.bookingUuid || data?.id,
        branch: data?.branch?.id,
        bank: selectedBank,
        billAmount: data?.loan?.disbursementAmount,
        collectedAmount: parseFloat(amount),
        changeReturned: 0,
        method: "Bank Transfer",
        status: "SUCCESS",
        collectedBy: loginCredintials?.id,
        date: date ? date.format("YYYY-MM-DD") : null,
        dateOfPayment: date ? date.toISOString() : null,
        eReceiptId: ReceiptId,
      };

      const response = await platformApi.post("/api/payment/create", payload);
      if (response.data.code === 200) {
        message.success("Payment created successfully!");
        const paymentRecord = response.data.response?.data;
        if (paymentRecord?.id) {
          window.open(
            `${ENDPOINT}api/payment/financer_due/receipt/${paymentRecord.id}?group=false`,
            "_blank"
          );
        }
        setSubmitting(false);
        close();
        if (typeof onPaymentSuccess === "function") {
          onPaymentSuccess();
        }
        return;
      } else {
        console.error("Child: Payment create error response:", response.data);
        message.error("Error creating payment");
      }
    } catch (err) {
      console.error("Child: Payment create exception:", err);
      message.error("Failed to create payment");
    } finally {
      console.log("Child: handleSubmit finally block, resetting submitting");
      setSubmitting(false);
    }
  };
  // --- Derived summary values ---
  const billAmount = parseFloat(data?.loan?.disbursementAmount || 0);
  const totalCollected = Array.isArray(data?.financePayments)
    ? data.financePayments.reduce(
      (sum, payment) => sum + (parseFloat(payment.collectedAmount) || 0),
      0
    )
    : 0;

  // Calculate current pending dynamically as user types
  const currentAmount = parseFloat(amount || 0);
  const pending = billAmount - totalCollected;
  const newPending = Math.max(pending - currentAmount, 0);
  return (
    <Modal
      visible={open}
      onCancel={close}
      onOk={handleSubmit}
      title="Financer Due"
      width={600}
      confirmLoading={submitting}
      destroyOnClose
    >

      {/* Bank dropdown */}
      <div style={{ marginBottom: 16 }}>
        <label style={{ fontWeight: 600 }}>Select Bank:</label>
        <br />
        <Select
          showSearch
          placeholder="Choose a bank"
          value={selectedBank}
          onChange={(value) => setSelectedBank(value)}
          onSearch={fetchBanks}
          filterOption={false}
          style={{ width: "100%", marginTop: 6 }}
        >
          {bankList.map((b) => (
            <Option key={b.key} value={b.value}>
              {b.label}
            </Option>
          ))}
        </Select>
      </div>

      {/* Amount input */}
      <div style={{ marginBottom: 16 }}>
        <label style={{ fontWeight: 600 }}>Amount:</label>
        <Input
          type="number"
          min={0}
          value={amount}
          onChange={(e) => {
            const val = e.target.value;
            if (val === "" || Number(val) >= 0) {
              setAmount(val);
            }
          }}
          onKeyDown={(e) => {
            if (["-", "e", "+"].includes(e.key)) {
              e.preventDefault();
            }
          }}
          placeholder="Enter amount"
          style={{ marginTop: 6 }}
        />
      </div>

      {/* Date picker */}
      <div style={{ marginBottom: 16 }}>
        <label style={{ fontWeight: 600 }}>Date:</label>
        <br />
        <DatePicker
          value={date}
          onChange={(d) => setDate(d)}
          style={{ width: "100%", marginTop: 6 }}
          format="DD-MM-YYYY"
          disabledDate={(current) => {
            if (!current) return false;
            if (current > moment().endOf("day")) {
              return true;
            }
            const allowPastDate = loginCredintials?.department?.allowPastDate;
            const pastDateLimit = loginCredintials?.department?.pastDateLimit;
            if (allowPastDate) {
              if (pastDateLimit !== undefined && pastDateLimit !== null) {
                const limitDate = moment().startOf("day").subtract(pastDateLimit, "days");
                return current < limitDate;
              }
              return false;
            } else {
              return current < moment().startOf("day");
            }
          }}
        />
      </div>

      {/* Summary */}
      <div
        style={{
          background: "#fafafa",
          borderRadius: 6,
          padding: 12,
          marginTop: 10,
        }}
      >
        <div>
          <strong>Cash to be collected:</strong> ₹{billAmount || 0}
        </div>
        <div>
          <strong>Total collected:</strong> ₹{totalCollected || 0}
        </div>
        <div>
          <strong>Pending:</strong>{" "}
          <span style={{ color: newPending > 0 ? "red" : "green" }}>₹{newPending || 0}</span>
        </div>
      </div>
    </Modal>
  );
}
